import axiosClient from './axiosClient';

const serviceOrdersApi = {
  // Ordenes de servicio (administrador y tecnico)
  getServiceOrders: (params) => axiosClient.get('/service-orders', { params }),
  createServiceOrder: (data) => axiosClient.post('/service-orders', data),
  updateServiceOrder: (id, data) => axiosClient.put(`/service-orders/${id}`, data),
  deleteServiceOrder: (id) => axiosClient.delete(`/service-orders/${id}`),
  // Se abrio el WhatsApp del cliente desde el panel: una orden "pendiente" pasa a "contacto".
  markServiceOrderContacted: (id) => axiosClient.post(`/service-orders/${id}/contacted`),

  // Solicitud de servicio del propio cliente (con cuenta o invitado), desde "/servicio-tecnico".
  // Se envia como multipart porque puede incluir fotos adjuntas (hasta 3).
  requestService: (formData) =>
    axiosClient.post('/service-requests', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),

  // Historial del cliente autenticado: sus propias ordenes de servicio ("/mis-ordenes-servicio")
  getMyServiceOrders: (params) => axiosClient.get('/service-orders/mine', { params }),

  // Catalogos de apoyo
  getServiceTypes: (params) => axiosClient.get('/service-types', { params }),
  createServiceType: (data) => axiosClient.post('/service-types', data),
  getServiceOrderStatuses: (params) => axiosClient.get('/service-order-statuses', { params }),

  // Selectores de cliente y tecnico
  searchClients: (search) => axiosClient.get('/service-orders/clients', { params: { search } }),
  getTechnicians: () => axiosClient.get('/service-orders/technicians'),

  // Dashboard: utilidad + pendientes vs terminadas (solo administrador)
  getServiceOrderStats: (granularity) => axiosClient.get('/service-orders/stats', { params: { granularity } }),
};

export default serviceOrdersApi;
